import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useReducer } from "react";
const initialCars = {
    cars: [],
    filteredCars: [],
    calcAttr: {
        maxDuration: 0,
        maxPrice: 0,
        minKm: 0,
    }
};
function carsReducer(state, action) {
    switch (action.type) {
        case "setFilteredCars":
            return {
                ...state,
                filteredCars: action.cars,
                ...(action.calcAttr && { calcAttr: action.calcAttr }),
            };
        case "setCars":
            return {
                ...state,
                cars: action.cars,
            };
        default:
            return state;
    }
}
export const CarsContext = createContext(initialCars);
// eslint-disable-next-line @typescript-eslint/no-empty-function
export const CarsDispatchContext = createContext(() => { });
export function CarsProvider({ children }) {
    const [context, dispatch] = useReducer(carsReducer, initialCars);
    return (_jsx(CarsContext.Provider, { value: context, children: _jsx(CarsDispatchContext.Provider, { value: dispatch, children: children }) }));
}
export function useCars() {
    return useContext(CarsContext);
}
export function useCarsDispatch() {
    return useContext(CarsDispatchContext);
}
